<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2023-09-20 16:45:09
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2025-09-11 10:49:40
 * @FilePath: \汇学堂Saas-企业中心pc\hxt-saas-pc\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { userCompanyInfo } from '@/api/index.js';


export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload,
      token: "",
    }
  },
  created() {
    // console.log(this.$route.query.show, 'this.$route.params.token1111111111111')

    var host = window.location.host;



    if (this.isWorkWechat()) {

      //判断只登陆个人企企微
      if (host !== 'zswpx.saas-test.taxchina.com' && process.env.NODE_ENV === 'development') {
        this.$message.error('当前域名无权访问!');
        setTimeout(() => {
          location.replace('http://zswpx.saas-test.taxchina.com/');
        }, 1000);
      } else if (process.env.NODE_ENV === 'production') {
        if (host !== 'zswpx.saas.taxchina.com') {
          this.$message.error('当前域名无权访问!');
          setTimeout(() => {
            location.replace('http://zswpx.saas.taxchina.com/');
          }, 1000);
        }

      }
    }


  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {// 判断设备企业微信
    isWorkWechat() {

      //获取user-agaent标识头
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua, 'ua------ window.navigator.userAgent.toLowerCase();----------------------------------------------------')
      //判断ua和微信浏览器的标识头是否匹配
      if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
        return true;
      } else {
        return false;
      }
    },
    getTodept() {

      if (this.token)
        userCompanyInfo({}, { Authorization: this.token, }).then(res => {
          if (res.code == 200) {
            localStorage.setItem('TopDeptId', res.data.topDeptId);
            localStorage.setItem('dept', res.data.deptId)
          }
        })
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  background: #F5F5F4;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.image {
  width: 100%;
  height: 100%;
}

@keyframes animi {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/* 定义滚动条的宽度和高度 */
::-webkit-scrollbar {
  width: 8px;
  /* 滚动条宽度 */
  height: 8px;
  /* 滚动条高度 */
}

/* 定义滚动条轨道的样式 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 滚动条轨道背景颜色 */
}

/* 定义滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  background: #888;
  /* 滑块颜色 */
}

/* 鼠标悬停时滚动条滑块的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 悬停时滑块颜色 */
}
</style>
